



























import Vue from 'vue';
import { IMobileMenuSetupComponent } from '@/common/interfaces/header.interface';
import { EMobileLanguageColors } from '@/common/enums/header.enum';
import MobileMenuBack from './MobileMenuBack.vue';
import MobileMenuHeadline from './MobileMenuHeadline.vue';

export default Vue.extend({
  name: `MobileLanguage`,
  components: { MobileMenuBack, MobileMenuHeadline },
  data(): IMobileMenuSetupComponent {
    return {
      EMobileLanguageColors,
      openedSetupMenu: false,
      showCurrenciesSelection: false,
      showLanguagesSelection: false,
    };
  },
  computed: {
    languageMenuVisible(): boolean {
      return (this.openedSetupMenu && this.showLanguagesSelection)
        || (this.openedSetupMenu && !this.showCurrenciesSelection);
    },
    title(): string {
      return `${this.chosenLanguage}`;
    },
  },
  props: {
    chosenLanguage: {
      required: true,
      type: String,
    },
    languages: {
      required: true,
      type: Array as () => string[],
    },
  },
  methods: {
    toggleSetupMenu(): void {
      if(this.showLanguagesSelection) {
        this.showLanguagesSelection = false;
        return;
      }
      this.openedSetupMenu = !this.openedSetupMenu;
      this.$emit(`changed:state`, this.openedSetupMenu);
    },
  },
});
